var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",staticClass:"btn-arrow",attrs:{"to":_vm.to,"target":_vm.target},on:{"click":_vm.triggerClick}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('ArrowRight',{staticClass:"arrow",class:{ noAnimation: _vm.noAnimation }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }